<template>
    <div class="details_body">
        <ul class="details_tab">
            <li @click="num = 0" :class="{active: num == 0}">模型编写视频教程简介</li>
            <li @click="num = 2" :class="{active: num == 2}">购买须知</li>
        </ul>
        <div class="details_gn" v-show="num == 0">
            <p>
                1.针对初级量化自学者定制<br />
                2.以视频为主配有PPT知识点学习指导和函数说明书<br />
                3.每个章节按了解概念->讲述方法->指导编写->分析案例的过程分步展开。<br />
                <a href="https://wt8.wenhua.com.cn/#/buy/videoClass" target="_blank">>>> 查看更多详细介绍及课程目录</a>
            </p>
            <div class="mai_detail">模型编写视频教程包括：麦语言量化应用培训基础班讲义1份、麦语言函数手册1份、U盘1个。</div>
            <p class="title">麦语言量化应用培训基础班讲义（150页）</p>
            <img style='width:600px;height:437px;' src="/img/peixun/2.png" alt="">
            <p class="title">麦语言函数手册（172页）</p>
            <img style='width:600px;height:437px;' src="/img/peixun/1.png" alt="">
            <p class="title">U盘（教学视频时长：9:52'，Mp4格式）</p>
            <img style='width:600px;height:365px;' src="/img/peixun/3.png" alt="">
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        <div class="details_gn" v-show="num == 2">
            <p class="tent">U盘是消耗品仅作为视频载体邮寄，在收到U盘后请尽快以其它方式保存视频，我公司不负责U盘售后服务。</p>
            
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                num: 2
            }
        },
    }
</script>
<style scoped src='./doc.css'></style>